import React, { useState, useEffect } from "react";
import { Modal, Button, Form, Dropdown } from "react-bootstrap";
import "./user-details.css";
import DataTable from "react-data-table-component";
import axios from "../../../axios/axios";
import { message } from "antd";
import LoadingOverlay from "react-loading-overlay";
import { ThreeDot } from "../../../assets/images";
import { CSVLink } from "react-csv";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { adminConfig } from "../../../utils/adminConfig";

const customStyles = {
  header: {
    style: {
      minHeight: "56px",
    },
  },
  headRow: {
    style: {
      borderTopStyle: "solid",
      borderTopWidth: "1px",
    },
  },
  headCells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "17px",
      color: "#004aad",
      whiteSpace: 'normal',   // Overrides the default "nowrap"
      wordBreak: 'break-word', // Breaks long words if necessary
    },
  },

  cells: {
    style: {
      "&:not(:last-of-type)": {
        borderRightStyle: "solid",
        borderRightWidth: "1px",
      },
      fontSize: "16px",
    },
  },
};

const UserDetailsTvi = () => {
  const history = useHistory();

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [loading, setLoading] = useState(false);
  const [resetPassword, setResetPassword] = useState(false);
  const [changeEmailModal, setChangeEmailModal] = useState(false);
  const [passwordShowHide, setpasswordShowHide] = useState(null);
  const [members, setMembers] = useState([]);
  const [csvData, setcsvData] = useState([]);
  const [pagination, setPagination] = useState({
    limit: 5,
    page: 1,
    totalPage: 7,
    totalRows: 10,
  });
  const [search, setSearch] = useState("");
  const [query, setQuery] = useState("");
  const [user_id, setUser_id] = useState(null);
  const [userEmailGet, setuserEmailGet] = useState(null);
  const [input, setInput] = useState({
    new_pass: "",
    conf_pass: "",
  });
  const [error, setError] = useState({
    new_pass: "",
    conf_pass: "",
  });
  const [changeEmailInput, setchangeEmailInput] = useState({
    secondaryEmail: "",
    isPrimaryEmail: false,
  });
  const [changeEmailInputerror, setchangeEmailInputError] = useState({
    secondaryEmail: "",
  });
  const [filter, setFilter] = useState({
    source: "",
  });

  const handlePerRowsChange = (newPerPage) => {
    setLimit(newPerPage);
    setPage(1);
  };

  const getMembers = () => {
    setLoading(true);
    axios
      .post(
        `/get-tvi-users/?limit=${limit}&page=${page}&search=${search}&filter=${filter.source}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error("failed fetching member");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const changePage = (newPage) => {
    setPage(newPage);
  };

  const showHidePasswordFun = (id) => {
    setpasswordShowHide(id);
  };

  const getFilterMembers = (filter) => {
    setLoading(true);
    axios
      .post(
        `/get-tvi-users/?limit=${limit}&page=${page}&search=${query}&filter=${filter}`,
        adminConfig()
      )
      .then((res) => {
        setLoading(false);

        if (res.data.status) {
          setMembers(res.data.data);
          setPagination(res.data.pagination);
        } else {
          message.error("failed fetching member");
        }
      })
      .catch((err) => {
        setLoading(false);

        console.log(err);
      });
  };

  const columns = [
    {
      name: "ID",
      selector: (row) => row?.id,
      sortable: true,
      width: "100px",
      wrap: true
    },
    {
      name: "Email",
      selector: (row) => row?.email,
      sortable: true,
      width: "200px",
      wrap: true
    },
    {
      name: "Secondary Email",
      selector: (row) => (row?.secondaryEmail) ? row?.secondaryEmail : "N/A",
      sortable: true,
      width: "200px",
      wrap: true
    },
    {
      name: "UserName",
      selector: (row) => row?.userName,
      sortable: true,
      width: "200px",
      wrap: true
    },
    {
      name: "Name",
      selector: (row) => row?.name,
      sortable: true,
      width: "150px",
      wrap: true
    },
    {
      name: "Phone",
      selector: (row) => row?.phone,
      sortable: true,
      width: "150px",
      wrap: true
    },
    {
      name: "Plan Name",
      selector: ({ packageDetails }) => packageDetails?.stripePlanName,
      width: "200px",
      wrap: true
    },
    {
      name: "Plan Price",
      selector: ({ packageDetails }) =>
        packageDetails?.packagePrice ? "$" + packageDetails?.packagePrice : "",
      width: "200px",
      wrap: true
    },
    {
      name: "Plan Expire",
      selector: ({ packageDetails }) => packageDetails?.expireDate,
      width: "150px",
      wrap: true
    },
    {
      name: "Plan Status",
      selector: ({ isSubscriptionCanceled }) =>
        isSubscriptionCanceled ? "Canceled" : "Active",
      width: "120px",
      wrap: true
    },
    {
      name: "Login Date",
      // selector: ({ sessionDetails }) =>
      //   sessionDetails.loginDate
      //     ? moment(sessionDetails.loginDate).format("MM-DD-YYYY")
      //     : "",
      selector: () => "",
      width: "150px",
      wrap: true
    },
    {
      name: "Source",
      selector: (row) => (row?.isVilocityUser ? "Vilocity" : "TVI"),
      sortable: true,
      width: "105px",
      wrap: true
    },
    {
      name: "Arrivia User Id",
      selector: (row) => row?.arriviaUserId,
      sortable: true,
      width: "200px",
      wrap: true
    },
    {
      name: "Affiliate",
      selector: (row) =>
        row?.affiliateDetails ? row?.affiliateDetails?.name : "",
      sortable: true,
      width: "130px",
      wrap: true
    },
    {
      name: "Paypal Id",
      selector: (row) => row?.paypalId,
      sortable: true,
      width: "130px",
      wrap: true
    },
    {
      name: "Direct Deposit",
      selector: (row) =>
        row?.commissionType === "Direct Deposit" ? "Yes" : "No",
      sortable: true,
      width: "150px",
      wrap: true
    },
    {
      name: "Created At",
      selector: (row) => moment(row?.createdAt).format("MM-DD-YYYY"),
      sortable: true,
      width: "150px",
      wrap: true
    },
    {
      name: "Password",
      selector: (row) => (
        <div>
          {passwordShowHide === row?.id ? (
            <>
              <span>{row?.passwordRaw}</span>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(null);
                }}
              >
                Hide
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-primary btn-sm ml-3"
                onClick={() => {
                  showHidePasswordFun(row?.id);
                }}
              >
                Show
              </button>
            </>
          )}
        </div>
      ),
      sortable: true,
      width: "130px",
      wrap: true
    },
    // {
    //   name: "status",
    //   selector: (row) => row.status,
    //   sortable: true,
    //   width: "200px",
    // },
    {
      name: "Action",
      selector: (row) => (
        <Dropdown drop="down" className="select_box_preassigneds">
          <Dropdown.Toggle variant="success" id="dropdown-basic">
            <img src={ThreeDot} alt="Action" />
          </Dropdown.Toggle>
          {/* <Dropdown.Menu popperConfig={popperConfig}> */}
          <Dropdown.Menu>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                setResetPassword(true);
                setUser_id(row?.id);
              }}
            >
              Reset Password
            </div>
            <div
              className={`dropdown-item ${row?.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row?.id, row?.arriaviaStatus !== '' ? 'active' : "");
              }}
            >
              Active
            </div>
            <div
              className={`dropdown-item ${!row?.status ? "disabled" : ""}`}
              role="button"
              onClick={() => {
                activeInactiveUser(row?.id, row?.arriaviaStatus !== '' ? 'inactive' : "");
              }}
            >
              Inactive
            </div>

            {/* <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                toggleStarBenifit(row.id);
              }}
            >
              {row.isStarBenifit
                ? "Star Benefit Inactive"
                : "Star Benefit Active"}
            </div> */}

            {/* {row?.arriaviaStatus != "" ? (
              <>
                {row?.arriaviaStatus == "Active" ? (
                  <>
                    <div
                      className="dropdown-item"
                      role="button"
                      onClick={() => {
                        arriviaUserActiveInactive(row?.id, "inactive");
                      }}
                    >
                      Arrivia Inactive
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="dropdown-item"
                      role="button"
                      onClick={() => {
                        arriviaUserActiveInactive(row?.id, "active");
                      }}
                    >
                      Arrivia Active
                    </div>
                  </>
                )}
              </>
            ) : (
              <></>
            )} */}
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                setChangeEmailModal(true);
                setUser_id(row?.id);
                setuserEmailGet(row?.email);
                setchangeEmailInput({
                  secondaryEmail: row?.secondaryEmail ? row?.secondaryEmail : "",
                  isPrimaryEmail: row?.isLoginWithSecondaryEmail ? true : false,
                });
              }}
            >
              Change Email
            </div>
            <div
              className="dropdown-item"
              role="button"
              onClick={() => {
                history.push(`/edit-affiliate/${row?.affId}`);
              }}
            >
              Change Affiliate
            </div>
          </Dropdown.Menu>
        </Dropdown>
      ),
      width: "90px",
    },
  ];

  useEffect(() => {
    getMembers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit, search]);

  const handelChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    setInput({
      ...input,
      [name]: value,
    });
  };

  const handelChangeEmail = (e) => {
    //e.preventDefault();
    let { name, value } = e.target;
    if (name == "isPrimaryEmail") {
      if (e.target.checked) {
        setchangeEmailInput({
          isPrimaryEmail: true,
          secondaryEmail: changeEmailInput.secondaryEmail,
        });
      } else {
        setchangeEmailInput({
          isPrimaryEmail: false,
          secondaryEmail: changeEmailInput.secondaryEmail,
        });
      }
    } else {
      setchangeEmailInput({
        secondaryEmail: value,
        isPrimaryEmail: changeEmailInput.isPrimaryEmail,
      });
    }
  };

  const resetPasswordFunction = (e) => {
    e.preventDefault();

    if (input.new_pass !== input.conf_pass) {
      setError({
        ...error,
        conf_pass: "Password and Confirm password not match.",
      });
    } else {
      setError({
        ...error,
        conf_pass: "",
      });

      let { new_pass, conf_pass } = input;

      const formData = {
        id: user_id,
        new_pass,
        conf_pass,
      };

      setError({});
      setInput({});
      setResetPassword(false);
      setUser_id(null);

      setLoading(true);

      axios
        .post("/reset-tviuser-password", formData, adminConfig())
        .then((res) => {
          setLoading(false);
          if (res.data.status) {
            message.success(res.data.message);
          } else {
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          console.error(err);
          setLoading(false);
        });
    }
  };

  const changeEmailSubmitFunction = (e) => {
    e.preventDefault();
    if (changeEmailInput.secondaryEmail === "") {
      setchangeEmailInputError({
        ...changeEmailInputerror,
        secondaryEmail: "Email is mandatory.",
      });
    } else {
      setLoading(true);
      const formData = {
        uid: user_id,
        secondaryEmail: changeEmailInput.secondaryEmail,
        isPrimaryEmail: changeEmailInput.isPrimaryEmail,
      };

      setchangeEmailInputError({});
      setchangeEmailInput({});
      setChangeEmailModal(false);
      setUser_id(null);
      setuserEmailGet(null);

      axios
        .post("/tvi-user-email-change", formData, adminConfig())
        .then((res) => {
          if (res.data.status) {
            setLoading(false);
            getMembers();
            message.success(res.data.message);
          } else {
            setLoading(false);
            message.error(res.data.message);
          }
        })
        .catch((err) => {
          setLoading(false);
          message.error("something went wrong!");
          console.error(err);
        });
    }
  };

  const activeInactiveUser = (id, statusType) => {
    setLoading(true);

    axios
      .post("/active-inactive-tviuser", { id }, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          // getMembers();
          // alert(statusType);
          // if (statusType === "active" || statusType === "inactive") {
          //   arriviaUserActiveInactive(id, statusType);
          // } else {
          //   getMembers();
          // }
          getMembers();
        } else {
          setLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const toggleStarBenifit = (id) => {
    setLoading(true);
    axios
      .post("/toggle-star-benefit", { id, source: "tvi" }, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          getMembers();
        } else {
          setLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const arriviaUserActiveInactive = (id, type) => {
    setLoading(true);
    let url;
    if (type === "active") {
      url = "/arrivai-active-user/" + id + "/tvi";
    } else {
      url = "/arrivai-deactive-user/" + id + "/tvi";
    }

    axios
      .get(url, adminConfig())
      .then((res) => {
        if (res.data.status) {
          message.success(res.data.message);
          getMembers();
        } else {
          setLoading(false);
          message.error(res.data.message);
        }
      })
      .catch((err) => {
        console.error(err);
        setLoading(false);
      });
  };

  const headersCsv = [
    { label: "Id", key: "id" },
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Secondary Email", key: "secondaryEmail" },
    { label: "UserName", key: "userName" },
    { label: "Phone", key: "phone" },
    { label: "Plan Name", key: "planName" },
    { label: "Plan Price", key: "planPrice" },
    { label: "Plan Expire", key: "planExpire" },
    { label: "Plan Status", key: "planStatus" },
    { label: "Login Date", key: "loginDate" },
    { label: "Source", key: "source" },
    { label: "Arrivia User Id", key: "arriviaUserId" },
    { label: "Paypal Id", key: "paypalId" },
    { label: "Direct Diposit", key: "directDiposit" },
    { label: "Created At", key: "createdAt" },
  ];

  const csvReport = {
    data: csvData,
    headers: headersCsv,
    filename: "TVI-user-list-" + moment().format("DDMMYYYY-HHmmss") + ".csv",
  };

  const csvdownload = async () => {
    setLoading(true);
    axios
      .post(
        `/get-export-tvi-users/?search=${search}&filter=${filter.source}`,
        adminConfig()
      )
      .then((res) => {
        if (res.data.status) {
          var csvData = [];

          res.data.data.forEach(function (allData) {
            csvData.push({
              id: allData?.id,
              name: allData?.name,
              email: allData?.email,
              secondaryEmail: (allData?.secondaryEmail) ? allData?.secondaryEmail : "N/A",
              userName: allData?.userName,
              phone: allData?.phone ? allData?.phone : "N/A",
              planName: allData?.packageDetails?.stripePlanName,
              planPrice: allData?.packageDetails?.packagePrice
                ? "$" + allData?.packageDetails?.packagePrice
                : "N/A",
              planExpire: allData?.packageDetails?.expireDate
                ? allData?.packageDetails?.expireDate
                : "N/A",
              planStatus: allData?.isSubscriptionCanceled
                ? "Canceled"
                : "Active",
              loginDate: "",
              source: allData?.isVilocityUser ? "Vilocity" : "TVI",
              arriviaUserId: allData?.arriviaUserId
                ? allData?.arriviaUserId
                : "N/A",
              paypalId: allData?.paypalId ? allData?.paypalId : "N/A",
              directDiposit:
                allData?.commissionType === "Direct Deposit" ? "Yes" : "No",
              createdAt: moment(allData?.createdAt).format("MM-DD-YYYY"),
            });
          });
          setcsvData(csvData);
          setTimeout(() => {
            document.getElementById("csvclick").click();
            setLoading(false);
          }, 2000);
        } else {
          setLoading(false);
          message.error("failed fetching member");
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  return (
    <LoadingOverlay spinner active={loading} text="Loading...">
      <Modal show={resetPassword}>
        <Modal.Header>
          <h4>Reset Password</h4>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={resetPasswordFunction}>
            <Form.Group className="mt-2">
              <Form.Label>New Password</Form.Label>
              <Form.Control
                name="new_pass"
                required
                value={input.new_pass}
                type="password"
                onChange={handelChange}
                placeholder="Type New Password"
              />
            </Form.Group>
            <Form.Group className="mt-2">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                name="conf_pass"
                required
                value={input.conf_pass}
                type="password"
                onChange={handelChange}
                placeholder="Type Confirm Password"
              />
              <p>{error.conf_pass}</p>
            </Form.Group>

            <div className="modal_footer_button mt-5">
              <Button
                onClick={() => {
                  setError({});
                  setInput({});
                  setResetPassword(false);
                  setUser_id(null);
                }}
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </Button>
              <Button type="submit" className="btn btn-primary ml-3">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal show={changeEmailModal}>
        <Modal.Header>
          <h4>Change Email</h4>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={changeEmailSubmitFunction}>
            <Form.Group className="mt-2">
              <Form.Label>Email</Form.Label>
              <Form.Control value={userEmailGet} type="text" disabled />
            </Form.Group>
            <Form.Group className="mt-2">
              <Form.Label>Secondary Email</Form.Label>
              <Form.Control
                name="secondaryEmail"
                required
                value={changeEmailInput.secondaryEmail}
                type="email"
                onChange={handelChangeEmail}
                placeholder="Type Secondary Email"
              />
              <input
                type="checkbox"
                name="isPrimaryEmail"
                onChange={handelChangeEmail}
                checked={changeEmailInput.isPrimaryEmail ? true : false}
              />
              Do you want to make secondary email the primary email address?
            </Form.Group>

            <div className="modal_footer_button mt-5">
              <Button
                onClick={() => {
                  setchangeEmailInputError({});
                  setchangeEmailInput({});
                  setChangeEmailModal(false);
                  setUser_id(null);
                  setuserEmailGet(null);
                }}
                type="button"
                className="btn btn-secondary"
              >
                Cancel
              </Button>
              <Button type="submit" className="btn btn-primary ml-3">
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <div className="right_cont">
        <div className="right_banner_banner_cnt">
          <div className="travel_deals_admin">
            <h2>Hello, Admin!</h2>
            <div className="text_field_partts">
              <div className="user_added">
                <div className="d-flex justify-content-between w-100">
                  <h2>Registered TVI Users List</h2>
                  <div className="input-group w-auto">
                    <div className="form-outline">
                      <input
                        placeholder="Type name, email or userName"
                        type="text"
                        id="form1"
                        className="form-control"
                        onChange={(e) => {
                          setQuery(e.target.value);
                        }}
                      />
                    </div>
                    <button
                      type="button"
                      className="btn btn-primary search_button"
                      onClick={() => {
                        if (query.length >= 3) {
                          setSearch(query);
                        } else {
                          message.warning(
                            "The entered input should be 3 or more than 3 characters"
                          );
                        }
                        // setPage(1);
                      }}
                    >
                      Search
                    </button>
                  </div>
                </div>
                <div className="row mb-3">
                  <div className="col-md-3">
                    <select
                      name="sourcefilter"
                      className="form-control"
                      id=""
                      onChange={(e) => {
                        setFilter({
                          source: e.target.value,
                        });
                        getFilterMembers(e.target.value);
                      }}
                    >
                      <option value="">All</option>
                      <option value="vilocity">Vilocity</option>
                      <option value="tvi">TVI</option>
                    </select>
                  </div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3"></div>
                  <div className="col-md-3">
                    <CSVLink className="d-none" id="csvclick" {...csvReport}>
                      Export to CSV
                    </CSVLink>
                    <button
                      type="button"
                      className="add_but submit_buttt mt-0"
                      onClick={() => {
                        csvdownload();
                      }}
                    >
                      CSV Export
                    </button>
                  </div>
                </div>

                <DataTable
                  columns={columns}
                  data={members}
                  pagination
                  striped
                  responsive
                  customStyles={customStyles}
                  subHeaderAlign="right"
                  subHeaderWrap
                  paginationDefaultPage={page}
                  paginationServer
                  paginationTotalRows={pagination.totalRows}
                  paginationPerPage={limit}
                  paginationRowsPerPageOptions={[5, 10, 15, 20, 40, 100]}
                  onChangeRowsPerPage={handlePerRowsChange}
                  onChangePage={changePage}
                  progressComponent={<CustomLoader />}
                  noDataComponent={<EmptyDataLoader />}
                  className={members.length === 1 ? "search_state" : ""}
                  fixedHeaderScrollHeight="500px"
                  fixedHeader
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </LoadingOverlay>

    //     </div>
    // </div>
  );
};
const CustomLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    <div>Loading...</div>
  </div>
);
const EmptyDataLoader = () => (
  <div
    style={{
      padding: "15px",
      background: "#495A71",
      color: "#fff",
      width: "100%",
      fontSize: "40px",
      textAlign: "center",
      minHeight: "350px",
      lineHeight: "400px",
    }}
  >
    {/* <div>No data found...</div> */}
  </div>
);
export default UserDetailsTvi;
